import DeleteProject from "@/v2/api/project/Delete";
import DeleteButton from "../general/Delete";

export default function ProjectDeleteButton({
    id,
    isInside = false,
}: {
    id: string;
    isInside?: boolean;
}) {
    return (
        <DeleteButton
            id={id}
            queryKey={["projects"]}
            deleteFn={DeleteProject}
            title="Delete Project"
            description="Are you sure you want to delete this project? This action cannot be undone. Click delete to confirm."
            successTitle="Project Deleted Successfully"
            isInside={isInside}
        />
    );
}
